var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.definitions),function(definition,index){return _c('li',{key:("Definition: " + index),staticClass:"text--body-responsive"},[_c('b',[_vm._v(_vm._s(definition.term))]),_vm._v(" "+_vm._s(definition.description)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }